<template>
    <div>
      <div class="content-header  primary_filters bulk-assign-btn ">
        <div class="content-header content-header-left pad0">
          <div class="filters-row">
            <div class="con-select">
              <div class="selection_search casetype ml-0">
                <div class="search">
                  <div class="vs-component vs-con-input-label vs-input is-label-placeholder vs-input-primary">
                    <div class="vs-con-input">
                      <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" :placeholder="'Invoice No/Beneficiary Name'"
                        class="is-label-placeholder" v-model.lazy="searchtxt" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="con-select selection_search selection_search-v2 pn_width">
            <div class="search">
              <div class="vs-component vs-con-input-label vs-input is-label-placeholder vs-input-primary">
                <div class="vs-con-input">
                  <multiselect @input="changedperitionersSearch()" v-model="header_selected_petitioners"
                    :options="petitionersList" :multiple="true" :hideSelected="true" :close-on-select="false"
                    :clear-on-select="false" :preserve-search="true" placeholder="Petitioner" label="name" track-by="name"
                    :preselect-first="false" @search-change="peritioners_search_fun">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                        Petitioner(s)</span>
                      <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                    </template>

                  </multiselect>
                  <!-- <multiselect  v-model="capvalues" :placeholder="'Petitioner'" :options="Petitioners"></multiselect> -->
                </div>
              </div>
            </div>
          </div>
            

          </div>
        </div>
        <div class="content-header-right">
          <!--filter dropdown-->
          <vs-dropdown vs-custom-content vs-trigger-click>
            <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
              icon-after>
              <img src="@/assets/images/main/icon-filter.svg" /> Filters
            </vs-button>
            <vs-dropdown-menu ref="filter_menu" class="filters-content">
              <div class="filters-form-fileds">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full con-select filters-search">
                      <label class="typo__label">Title</label>
                      <vs-input :key="'filter_searchtxt'" icon-pack="feather" icon placeholder="Search by Invoice No/Beneficiary"
                        class="is-label-placeholder" v-model="filter_searchtxt" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select"
                     >
                      <label class="typo__label">Petitioner</label>
                      <multiselect @input="changedperitioners()" v-model="selected_peritioners" :options="petitionersList"
                        :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                        :preserve-search="true" placeholder="Select Petitioner" label="name" track-by="name"
                        :preselect-first="false" @search-change="peritioners_search_fun">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Petitioner(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                      </multiselect>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Case Type</label>
                    <multiselect @input="changedVisaType" v-model="selectedVisaType" :options="visaTypes"
                      :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select Case Type" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case
                          Type(s) Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>

                  <!---all_subtypes---->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Case Subtype</label>
                    <multiselect @input="changedsubtypes()" v-model="selected_subtypes" :disabled="selectedVisaType == null"
                      :options="all_subtypes" :multiple="true" :hideSelected="true" :close-on-select="false"
                      :clear-on-select="false" :preserve-search="true" placeholder="Select Case Subtype" label="name"
                      track-by="name" :preselect-first="false">

                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case
                          Subtype(s) Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Status</label>
                    <multiselect v-model="selected_statusids" :options="case_statusids" :multiple="true"
                      :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="id" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                          Status Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Payment Status</label>
                    <multiselect v-model="selected_paymentstatusids" :options="paymentStatus" :multiple="true"
                      :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="id" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                          Status Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div> 
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker :maxDate="new Date()" :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="selected_createdDateRange"></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Due Date</label>

                    <date-range-picker :autoApply="autoApply" :ranges="false" :opens="'left'"
                      v-model="selected_deadLineDateRange"></date-range-picker>
                  </div> 
                    
                  </div>
                </div>
              </div>
              <div class="filters-status">
                <div class="left-buttons"></div>
                <div class="right-buttons">
                  <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                  <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear</vs-button>
                </div>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button v-if="[3,13].indexOf(getUserRoleId)>-1" color="primary" type="border" class="light-blue-btn"
          @click="$router.push('/generate-invoice')">Generate Invoices
          <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
          </span>
        </vs-button>
        </div>
      </div>
      <NoDataFound ref="NoDataFoundRef" :loading="isListloading" v-if="invoiceList.length == 0" content=""
        :heading="callFromSearch ? 'No Results Found' : 'No Cases Found'" type='petitions' />
      <div class="accordian-table custom-table cpr_table 1" v-if="invoiceList.length > 0">
        
        <div class="vs-table--content">
          <div class="vs-con-tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th>
  
                    <div class="vs-table-text d-flex">
                      <a @click="sortMe('customId')"
                        v-bind:class="{ 'sort_ascending': sortKeys['customId'] == 1, 'sort_descending': sortKeys['customId'] != 1 }">Invoice No
                      </a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('IssuedToDetails')"
                        v-bind:class="{ 'sort_ascending': sortKeys['IssuedToDetails'] == 1, 'sort_descending': sortKeys['IssuedToDetails'] != 1 }">Issued To</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('createdOn')"
                        v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }">Issued On</a>
                    </div>
                  </th>
                  
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('amount')"
                        v-bind:class="{ 'sort_ascending': sortKeys['amount'] == 1, 'sort_descending': sortKeys['amount'] != 1 }">Amount</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('caseType')"
                        v-bind:class="{ 'sort_ascending': sortKeys['caseType'] == 1, 'sort_descending': sortKeys['caseType'] != 1 }">Case Type</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('beneficiaryName')"
                        v-bind:class="{ 'sort_ascending': sortKeys['beneficiaryName'] == 1, 'sort_descending': sortKeys['beneficiaryName'] != 1 }">Beneficiary</a>
                    </div>
                  </th>
                  <!-- <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('createdOn')"
                        v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }">Issued On</a>
                    </div>
                  </th> -->
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('caseStatus')"
                        v-bind:class="{ 'sort_ascending': sortKeys['caseStatus'] == 1, 'sort_descending': sortKeys['caseStatus'] != 1 }">Case Status</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('paymentStatus')"
                        v-bind:class="{ 'sort_ascending': sortKeys['paymentStatus'] == 1, 'sort_descending': sortKeys['paymentStatus'] != 1 }">Payment Status</a>
                    </div>
                  </th>
                  <th class="actions">Actions
                 </th>
                </tr>
              </thead>
              <!-- class="cursor-pointer" -->
              <tr class="vs-table--tr" v-for="(petition, index) in invoiceList" :key="index">
                <td class="td vs-table--td cursor-pointer">
                  <span @click="showDetails(petition)">
                    <div class="d-flex align-center" > {{ petition.customId }}
                      <span class="pl-2">
                          <template v-if="checkProperty(petition, 'qbInvoiceId')">
                            <svg id="Group_76375" data-name="Group 76375" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24.004 24.004">
                              <circle id="Ellipse_574" data-name="Ellipse 574" cx="9.002" cy="9.002" r="9.002" transform="translate(2.4 2.529)" fill="#fff"/>
                              <g id="check">
                                <g id="Group_8119" data-name="Group 8119">
                                  <path id="Path_34467" data-name="Path 34467" d="M12,0A12,12,0,1,0,24,12,12.049,12.049,0,0,0,12,0ZM10.55,17.461,5.294,12.205l1.989-1.989,3.359,3.359,6.743-6.13,1.893,2.081Z" fill="#27a438"/>
                                </g>
                              </g>
                            </svg>
                        </template> 
                        <template v-if="checkProperty(petition, 'qbErrorMessage')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><defs></defs><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z" fill="#ec1c24"/></svg>
                        </template>
                      </span>                    
                    </div>
                  </span>
                </td>
                <td class="td vs-table--td">
                  <span >
                    <div  > {{checkProperty(petition, 'IssuedToDetails')}} </div>
                  </span>
                </td>
                <td class="td_label">
                  <div >
                      {{checkProperty(petition, 'createdOn') |formatDate}} <br />
                      <small v-if="checkProperty(petition, 'createdByDetails', 'name')">{{ checkProperty(petition, 'createdByDetails', 'name') }} 
                        <template v-if="checkProperty(petition, 'createdByDetails', 'roleName')">({{ checkProperty(petition, 'createdByDetails', 'roleName')}}) </template>
                      </small>
                    </div>
                 
                </td>
                <td class="td vs-table--td">
                  <template v-if="petition && (petition.amount || petition.amount == 0) ">{{formatprice(petition.amount)}}</template>
                    
                </td>
                <td class="td_label" >
                  <div >
                    {{ checkProperty(petition, 'petitionDetails', 'typeName') }} <br />
                    <small> {{ checkProperty(petition, 'petitionDetails', 'subTypeName') }} </small>
                  </div>
              </td>
                <td class="td_label">
                  <span :title="checkProperty(petition['petitionDetails'], 'beneficiaryInfo', 'name')" class="wrd-substr cursor-pointer" >{{
                    checkProperty(petition['petitionDetails'], 'beneficiaryInfo', 'name')
                  }}</span>
                  <span >
                    <small> {{ checkProperty(petition['petitionDetails'] ,'beneficiaryInfo','email') }} </small>
                  </span>
                </td>
                <!-- <td class="td_label">
                  <div >
                      {{checkProperty(petition, 'createdOn') |formatDate}} <br />
                      <small v-if="checkProperty(petition, 'createdByDetails', 'name')">{{ checkProperty(petition, 'createdByDetails', 'name') }} 
                        <template v-if="checkProperty(petition, 'createdByDetails', 'roleName')">({{ checkProperty(petition, 'createdByDetails', 'roleName')}}) </template>
                      </small>
                    </div>
                 
                </td> -->
                <td class="td vs-table--td">
                    <span :statusId="checkProperty(petition, 'caseStatusDetails', 'id')" class="statusspan "
                  v-bind:class="{ [getCaseColors(checkProperty(petition, 'caseStatusDetails', 'id'))]: true }">
                  {{ checkProperty(petition, 'caseStatusDetails', 'name') }}
                </span>

                </td>
                <td class="td vs-table--td">
                    <span :statusId="checkProperty(petition, 'statusDetails', 'id')" class="statusspan "
                  v-bind:class="{ [getCaseColors(checkProperty(petition, 'statusDetails', 'id'))]: true }">
                  {{ checkProperty(petition, 'statusDetails', 'name') }}
                </span>
                  <!-- <span >
                    <span
                    v-if="(!checkProperty(petition, 'statusDetails', 'id') || (checkProperty(petition, 'statusDetails', 'id')))"
                    class="statusspan cursor-pointer" v-bind:class="{
                      ' status_created ': checkProperty(petition, 'statusDetails', 'id') == 1 || checkProperty(petition, 'statusDetails', 'id') == 11,
                      ' status_submited ': checkProperty(petition, 'statusDetails', 'id') == 2,
                      ' status_inProcess ': checkProperty(petition, 'statusDetails', 'id') == 3,
                      ' status_verified ': checkProperty(petition, 'statusDetails', 'id') == 4,
                      ' status_registered ': checkProperty(petition, 'statusDetails', 'id') == 5,
                      ' status_submited-USCIS ': checkProperty(petition, 'statusDetails', 'id') == 6,
                      ' status_selected': checkProperty(petition, 'statusDetails', 'id') == 7,
                      ' status_not_selected ': checkProperty(petition, 'statusDetails', 'id') == 8,
                      ' status_denied': checkProperty(petition, 'statusDetails', 'id') == 9,
                      ' status_payment_failed ': checkProperty(petition, 'statusDetails', 'id') == 10,
                    }">{{ checkProperty(petition, 'statusDetails', 'name') }}
                    </span>
                  </span> -->
                </td>
                <td>
                    <vs-dropdown
                  class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent>
                    <more-vertical-icon size="1.5x" class="custom-class cursor"></more-vertical-icon>
                  </a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item>
                      <a href.prevent style="cursor:pionter;padding:3px 10px" @click="showDetails(petition)"><span>Show Details</span></a>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="table_footer">
          <div class="vx-col  con-select pages_select" v-if="invoiceList.length > 0">
            <label class="typo__label">Per Page</label>
            <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true">
  
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate v-if="invoiceList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
            :margin-pages="2" :click-handler="pageNate"
            prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
            next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
            :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
          </paginate>
        </div>
      </div>
  <!---showDetailsPopup-->
    <div  v-if="showDetailsPopup" class="workflow_view_wrap taskmanagement emailtemplate" :class="{ listopen: showDetailsPopup }">
        <div class="workflow_overlay"></div>
        <div class="workflow_view_cnt questionary_cnt bulkemail_details" style="width:900px">
          <div class="workflow_view_title view__title email_title-v2" :class="{ 'pr-0': type == 'showWorkflowview' }" >
            <span class="close" @click="showDetailsPopup = false;getInvoiceList()"><x-icon size="1.5x" class="custom-class"></x-icon></span>
          </div> 
            <invoiceDetail :ref="'invoiveDetailsPopup'" @reloadDetails="reloadDetails" v-if="invoiceDetails" @download_or_view="download_or_view" :invoiceData="invoiceDetails" />
          <div> 
          </div>
          
        </div>
        
      </div>
      <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>

        <!-- <span :class="{'pdf_view_close':docType == 'pdf', 'office_view_close':docType == 'office'  , 'image_view_close 33':docType =='image'}" class="close close2" @click="docPrivew= false"></span> -->
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
    </vs-popup>
  
  
    </div>
  </template>
  <script>
  import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
  import immiPhone from "@/views/forms/fields/phonenumber.vue";
  const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import Paginate from "vuejs-paginate";
  import moment from 'moment'
  import _ from "lodash";
  import Vue from 'vue'
  import NoDataFound from "@/views/common/noData.vue";
  import Multiselect from "vue-multiselect-inv";
  import JQuery from "jquery";
  import addBenewPet from "@/views/common/invitePet.vue"
  import addBeneficiary from "@/views/common/addBeneficiary.vue"

  import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import FileUpload from "@/views/FileUpload.vue";

  import invoiceDetail from "@/views/invoice/invoiceDetails.vue"
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    watch: {
      "$store.state.manageCapRegistrations":function(value){
              this.showCapRegistrations =value;
          },
      searchtxt: function (value) {
        let text = value.trim();
        this.page = 1
        if (text.length > 3 || text == '') {
          this.getInvoiceList(true, false);
        }
  
      },
    },
    data: function () {
      return {
        formSubmited: false,

        expandModal: false,
        docPrivew: false,
        showCloseIcon:false,
        showConfrmLetterPopup:false,
        docValue: "",
        docType: "",
        selectedFile: null,
        invoiceDetails:null,
        selectedFeeItem:null,
        updatedInitStatus: [
        { _id: "637f7c565648c5150123dall", id: 9, "name": "All", "sortName": "All" },
        { _id: "637f7c565648c5150123deab", id: 1, name: "Active", sortName: "active" },
        { _id: "637f7c565648c5150123dfiled", id: 10, "name": "Filed", "sortName": "Filed" },
        { _id: "637f7c565648c5150123deac", id: 2, name: "On Hold", sortName: "on hold" },
        { _id: "637f7c565648c5150123dead", id: 3, name: "Abandoned", sortName: "abandoned" },
        { _id: "637f7c565648c5150123deae", id: 4, name: "Deleted", sortName: "deleted" }
      ],
      getFiledCasesFiltered: false,
      initStatusIdsFilter:null,
        archiving: false,
        internalErrMsg: '',
        docValue:[],
        uploading: false,
        permDeleteDocs: [],
        editor: ClassicEditor,
        internalComments: '',
        internalStatusDetails: null,
        selectedAllForArchive: false,
        selectedForArchiveList : [],
        internalStatusList:[],
        checkHeaderCheckBox: { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" },
        editorConfig: {
        toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
      },
        showCapRegistrations:false,
        debounce:null,
        canRegCap:null,
        showCapErrorCreatioInfo:false,
        isSlg: true,
        capCreationErrors: '',
        newCapFormSubmited: false,
        withAccount: 'true',
        newBeneficiary: [
          {
            firstName: '',
            middleName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ],
        bulkBeneficiary: false,
        jsonData: [
          { "name": "SR", "email": 'ravis@innvectra.com' },
          { "name": "Ravi Kumar", "email": 'ravi@innvectra.com' }
        ],
        formerrors: {
          msg: ''
        },
        headerSelectedCaseTypes: [],
        selectedSeasons: [],
        selectedpremiumProcessing: [],
        premiumProcessingList: [{ name: 'Yes', _id: true }, { name: 'No', _id: false }],
        selectedStatus: [],
        caseStatusList: [],
        selectedEducations: [],
        education_types: [],
        selectedtypeNames: [],
        headerTypeNames: [],
        autoApply: '',
        disableOffice: false,
        branchList: [],
        selectedBranch: null,
        premiumProcessing: false,
        petitionersList: [],
        beneficiaryMasterDataList: [],
        selectedPetitioner: null,
        selectedBeneficiary: null,
        selectedUsername: null,
        selectedUser: null,
        invoiceList: [],
        sortKeys: {},
        sortKey: {},
        page: 1,
        perpage: 25,
        totalpages: 0,
        totalCount:0,
        perPeges: [10, 25, 50, 75, 100, 500],
        callFromSearch: false,
        isListloading: false,
        filter_searchtxt: '',
        searchtxt: '',
        header_selected_petitioners: [],
        selected_peritioners: [],
        final_selected_peritioners: [],
        encodedString: '',
        selected_createdDateRange: ["", ""],
        /////
        enableNextBtn: false,
        selectAllForArchive: false,
        selectedItem: false,
        value: null,
        values: null,
        capvalues: null,
        Petitioner: null,
  
        selected: null,
        selecte: null,
        AddBeneficiary: false,
        addPetitionerr: false,
        addcprbeneficiary: false,
        NewPetition: false,
        anonymousUser: false,
        options: ['10th / 12th Grade', 'Bachelors', 'Associate', 'Masters'],
        optionscase: ['Active', 'In active'],
        cap: [{ "name": 'Master Cap', "id": true, },
        { "name": 'Regular Cap', "id": false, }],
        Petitioneroptions: ['James', 'Michael'],
        caps: ['Master Cap', 'Regular Cap'],
        Petitioners: ['James', 'Michael'],
        season: [],
        fromUserList: ['Created', 'Sent for Petitioner Authorization', 'Petitioner Confirmation', 'Attorney Approval', 'Receipt of Payment Made', 'Submitted to USCIS', 'Selected', 'Petition Created'],
        //beneficiaryMasterDataList:['Rahul krishna' , 'Sathish'],
        PetitionerMasterDataList: ['Rahul krishna', 'Sathish'],
  
        selected_deadLineDateRange: ["", ""],
        wiseSelection: 'true',
        activeCases: true,
        getFiledCases: false,
        showDetailsPopup:false,
        selectedVisaType: null,
        visaTypes: [],
        selected_subtypes: [],
        all_subtypes: [],
        selected_statusids: [],
        case_statusids: [],
        final_selected_statusids: [],
        paymentStatus:[
    {
        "id":1,
        "name":"Created"
    },
    {
        "id":2,
        "name":"Sent"
    },
    // {
    //     "id":3,
    //     "name":"Delivery Error"
    // },
    // {
    //     "id":4,
    //     "name":"Viewed"
    // },
    {
        "id":5,
        "name":"Partially Paid"
    },
    {
        "id":6,
        "name":"Fully Paid"
    },
    // {
    //     "id":7,
    //     "name":"Deposited"
    // },
    // {
    //     "id":8,
    //     "name":"Pending"
    // }
],
        selected_paymentstatusids:[],
        final_selected_paymentstatusids:[],
        petition:null
  
      }
    },
    components: {
      invoiceDetail,
      XIcon,
      MoreVerticalIcon,
      immiPhone,
      immiInput,
      //bulkBeneficiary,
      Multiselect,
      Paginate,
      NoDataFound,
      addBeneficiary,
      addBenewPet,
      //addBeneficiary,
      //addPetitioner,
      Datepicker,
      DateRangePicker,
      FileUpload,
  
    },
    methods: {
      getWorkflowDetails(){
        
      },
      download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(value ,'viewmode') && this.checkProperty(value,'viewmode')==false ) {
          this.selectedFileForEdit =true;
      }

      this.expandModal= false;

      if (
        this.checkProperty(this.getPetitionDetails, "caseNo") &&
        this.checkProperty(value, "name")
      ) {
        let docName = _.cloneDeep(value["name"]);
        
        try{
          if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
            value["name"] = docName;
          }
        }catch(err){

        }

        
      }

      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;

            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }

            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId'] 
               ){
                //&& !value['parentId'] removed parentId in above condition as per requirement
                this.showCloseIcon = true; 
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              } 
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.petition._id,
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.petition._id,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },

              documentType: "word",
              height: "100%",
              width: "100%",

              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }

          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }
            //else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
            
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             

            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                  
                 }
              }

            }

           
            
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
              
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
    reloadDetails(){
      if(this.checkProperty(this.selectedFeeItem, '_id')){
        this.getDetails(this.checkProperty(this.selectedFeeItem, '_id'), true)
      }
    },
        getDetails(invoiceId, callFromReload=false){

      let query ={  
        "invoiceId": invoiceId?invoiceId:''
         };    
         this.$store
          .dispatch("getList",{data:query ,path:'/invoices/details'} )
          .then(response => {
             this.invoiceDetails = response;
             if(callFromReload){
              this.$refs['invoiveDetailsPopup'].checkPaidAmount()
             }
             //console.log(JSON.stringify(response))
             this.showDetailsPopup =true;
            }).catch(error => {
             
            })
        },
        formatprice(amount) {
      return formatter.format(amount);
    },
        changedVisaType(item) {
      // this.$router.push({ query: {} });
      this.selectedVisaType = item;
      this.all_subtypes = [];
      this.final_selected_subtypes = [];
      this.selected_subtypes = [];
      this.selected_statusids = [];
      if (_.has(this.selectedVisaType, "id")) {
        this.getvisa_subtypes();

      }
     // this.caseStatus(this.selectedVisaType);
      //this.setQueryString()
    },
        getVisaTypes() {
      let item = {
        matcher: {
          "searchString": '',
          getWorkFlowConfig: true
          // "petitionType":

        },
        page: this.page,
        perpage: this.perpage,
        category: "petition_types",
        "sorting": {
          "path": "name",
          "order": 1
        }

      };

      this.$store
        .dispatch("getMasterData", item)
        .then(response => {
          this.visaTypes = [];
          let placedobj = null
          let obj = { "_id": "632953d43ecbeaeefe93efefr", "id": 'ALL', "name": "All", "isCaseTypeSelected": true }
          placedobj = _.find(this.visaTypes, { 'id': 'ALL' })
          if (placedobj == null || !placedobj) {
            this.visaTypes.push(obj)
          }

          _.forEach(response.list, (item) => {
            this.visaTypes.push(item)
          });


          this.filterQueryPreSelect();




        });
    },
    getvisa_subtypes() {
      if (this.selectedVisaType && _.has(this.selectedVisaType, "id")) {
        let item = {
          matcher: {
            getAllSubTypes: false,
            searchString: '',
            petitionType: parseInt(this.selectedVisaType['id']),
            getWorkFlowConfig: false,
          },
          page: 1,
          perpage: 1000,
          category: "petition_sub_types",
          "sorting": {
            "path": "name",
            "order": 1
          }
        };

        if (this.selectedVisaType['id'] == 'ALL') {
          item['matcher']['petitionType'] = null;
          item['matcher']['getAllSubTypes'] = true;
        }

        this.$store.dispatch("getMasterData", item).then((response) => {
          this.all_subtypes = response.list;
          if (this.checkProperty(this.$route, 'query', 'filter')) {
            try {
              let filter = this.$route['query']['filter']; this.checkProperty(this.$route, 'query', 'filter')
              var actual = JSON.parse(atob(filter));
              let keys = Object.keys(actual);
              if (this.checkProperty(keys, 'length') > 0) {
                if (actual && (Object.keys(actual)).length > 0) {
                  _.forEach(actual, (item, key) => {
                    if (key == 'matcher') {
                      if ((Object.keys(item)).length > 0) {
                        if (_.has(item, 'subTypeIds') && this.checkProperty(item, 'subTypeIds', 'length') > 0) {
                          this.final_selected_subtypes = item['subTypeIds'];
                          if (this.all_subtypes.length > 0) {
                            this.selected_subtypes = _.filter(this.all_subtypes, (status) => {
                              return item['subTypeIds'].indexOf(status['id']) > -1;
                            })
                          }
                        }
                      }
                    }
                  })
                }
              }

            } catch (e) {
            }
          }
          // this.filterQueryPreSelect();

        });
      }
    },
    changedsubtypes() {

this.selected_statusids = null;
this.final_selected_subtypes = [];
if (this.selected_subtypes.length > 0) {
  for (let ind = 0; ind < this.selected_subtypes.length; ind++) {
    let current_index = this.selected_subtypes[ind];
    this.final_selected_subtypes.push(current_index["id"]);
    if ([15, 16, 17].indexOf(current_index['id']) > -1) {
      this.caseStatus(this.selected_subtypes);
    }
  }
}
else {
  this.caseStatus();
}
},
caseStatus(obj) {
      let selectedItem = null
      if (obj) {
        selectedItem = obj
      }

      let postData = {
        "matcher": {
          "searchString": "",
          "tenantId": "",
          "branchId": "",
          "getWorkFlowConfig": false,
          "getCasenoCodeConfig": false,
          "tenantCustomId": "",
          "petitionTypes": [],
          "getInactiveListAlso": false,
          "caseType": ""
        },
        "category": "case_status",
        "page": 1,
        "perpage": 25,
        "sorting": {
          "path": "name",
          "order": 1
        }
      }
      if (selectedItem && this.checkProperty(selectedItem, 'id') == 1) {
        postData['matcher']['caseType'] = "h1b"
      }
      if (selectedItem && this.checkProperty(selectedItem, 'id') == 2) {
        postData['matcher']['caseType'] = "h4"
      }
      if (selectedItem && this.checkProperty(selectedItem, 'id') == 3) {
        postData['matcher']['caseType'] = "gc"
      }
      if (selectedItem == null) {
        postData['matcher']['caseType'] = ""
      }
      if (this.selected_subtypes && this.checkProperty(this.selected_subtypes, 'length') == 1) {
        _.forEach(this.selected_subtypes, (item) => {
          if (item['id'] == 15) {
            postData['matcher']['caseType'] = "perm"
          }
          if (item['id'] == 16) {
            postData['matcher']['caseType'] = "i-140"
          }
          if (item['id'] == 17) {
            postData['matcher']['caseType'] = "i-485"
          }

        })
      }

      //alert(JSON.stringify(this.selectedVisaType))  
      if (this.checkProperty(this.tenantDetails, "customId")) {
        postData['matcher']['tenantCustomId'] = this.tenantDetails['customId'];
      }  //"get_case_statusids"  //getMasterData
      this.$store.dispatch("getMasterData", postData).then(response => {
        //alert(JSON.stringify(response))

        let list = response.list;
        if (this.selected_subtypes && this.checkProperty(this.selected_subtypes, 'length') == 1) {
          if (_.find(this.selected_subtypes, { "id": 17 })) {
            list = _.filter(list, (status) => {
              return status.id != 3
            });
          }
        }
        this.case_statusids = list
        if (this.checkProperty(this.$route, 'query', 'filter')) {
          try {
            let filter = this.$route['query']['filter']; this.checkProperty(this.$route, 'query', 'filter')
            var actual = JSON.parse(atob(filter));
            let keys = Object.keys(actual);
            if (this.checkProperty(keys, 'length') > 0) {
              if (actual && (Object.keys(actual)).length > 0) {
                _.forEach(actual, (item, key) => {
                  if (key == 'matcher') {
                    if ((Object.keys(item)).length > 0) {
                      if (_.has(item, 'statusIds') && this.checkProperty(item, 'statusIds', 'length') > 0) {
                        let statusIds = _.map(item['statusIds'], (sid) => parseInt(sid))

                        //let selectedStatus = _.find(this.case_statusids ,{"id":parseInt(statusIds[0])}); 
                        this.final_selected_statusids = statusIds;

                        let selectedStatus = _.filter(this.case_statusids, (itm) => statusIds.indexOf(itm.id) > -1)

                        if (selectedStatus) {
                          this.selected_statusids = selectedStatus //[selectedStatus];

                        }
                        if (!_.find(selectedStatus, { "id": 31 }) && statusIds.indexOf(31) > -1) {
                          let withdrawn = { "_id": "64429dc92535f74f9af0615b", "id": 31, "name": "Withdrawn", "sortName": "withdrawn" };
                          this.selected_statusids.push(withdrawn);
                        }




                      }
                    }
                  }
                })
              }
            }
          } catch (e) {
          }
        }
        if (this.checkProperty(this.$router.currentRoute, "query", "status")) {
          let status = this.checkProperty(this.$router.currentRoute, "query", "status");
          let selectedStatus = _.find(this.case_statusids, { "id": parseInt(status) });
          if (selectedStatus) {
            this.selected_statusids = [selectedStatus];
            this.final_selected_statusids = [parseInt(status)];
          }
        }

      })
    },
        showDetails(item){
          this.selectedFeeItem = null;
          if(item){
            this.selectedFeeItem = item;
            this.getDetails(this.checkProperty(item, "_id"))
          }
          
        },
      changedInitStatus(obj) {
        if (obj && obj.id == 1 || obj.id == 10 || obj.id == 9) {
          this.selected_statusids = [];
        }
        if(obj.id==10){
          this.getFiledCasesFiltered = true
        }else{
          this.getFiledCasesFiltered = false
        }
        //  _.filter(obj, (item) => {
        //  if(this.checkProperty(obj, 'id') != this.checkProperty(item, 'id')){
        //   this.activeCases =false;
        //  }
        // })
        // if(this.checkProperty(obj, 'id')==1){
        //   this.activeCases = true;
        // }
      },
  updateData(docs, category) {
        if (category == 'delete') {
          this.permDeleteDocs = docs;
        }
      },
      checkDeletedDocs(val) {
        this.internalErrMsg = ''
        if (this.checkProperty(val, 'id') == 1 || this.checkProperty(val, 'id') == 4) {
          this.permDeleteDocs = []
        }
      },
      selectAllforArchive() {
        this.formerrors.msg = '';
        this.selectedForArchiveList = [];
        _.forEach(this.invoiceList, (item) => {
          item.selectedForArchive = false;
          if (this.selectedAllForArchive && this.checkProperty(item, 'status') != false) {
            item.selectedForArchive = true;
            this.selectedForArchiveList.push(item._id)
  
          }
  
        })
  
        if (this.invoiceList.length > 0 && this.invoiceList.length != this.selectedForArchiveList.length) {
          this.selectedAllForArchive = false;
        }
  
  
  
      },
      filterInternalStatus() {
        this.internalStatusList = _.cloneDeep(this.masterDataList)
        if ([50].indexOf(this.getUserRoleId) > -1) {
          this.internalStatusList = _.filter(this.internalStatusList, (item) => {
            return [1, 4].indexOf(item.id) <= -1
          })
        }
        if (this.initStatusIdsFilter) {
          let filterStatusId = parseInt(this.checkProperty(this.initStatusIdsFilter, 'id'))
          if (filterStatusId == 3) {
            this.internalStatusList = _.filter(this.internalStatusList, (item) => {
              return [filterStatusId, 1].indexOf(item.id) <= -1
            })
          }
          else {
            this.internalStatusList = _.filter(this.internalStatusList, (item) => {
              return [filterStatusId].indexOf(item.id) <= -1
            })
          }
        }
      },
      getInternalStatusList() {
        let postData = {
          page: 1,
          perpage: 1000,
          category: "case_internal_status",
        }
        this.$store.dispatch("getMasterData", postData).then(response => {
          this.masterDataList = response.list;
  
          if ([50].indexOf(this.getUserRoleId) > -1) {
            this.internalStatusList = _.filter(response.list, (item) => {
              return [1, 4].indexOf(item.id) <= -1
            })
          }
          else {
            this.internalStatusList = this.masterDataList
          }
          if (this.checkProperty(this.$route, 'query', 'filter')) {
            try {
              let filter = this.$route['query']['filter']; this.checkProperty(this.$route, 'query', 'filter')
              var actual = JSON.parse(atob(filter));
              let keys = Object.keys(actual);
              if (this.checkProperty(keys, 'length') > 0) {
                //initStatusIdsFilter
  
                if (_.has(actual, 'matcher')) {
                  if (_.has(actual['matcher'], 'intStatusIds') && this.checkProperty(actual['matcher'], 'intStatusIds', 'length') > 0) {
                    let selectedIntStsid = actual['matcher']['intStatusIds'][0];
                    this.initStatusIdsFilter = _.find(this.internalStatusList, { 'id': selectedIntStsid });
                  }
                }
  
              }
  
            } catch (e) {
            }
          }
        });
      },
      
     
      openCreateCasePopup(action) {
        this.capCreationErrors = '';
        this.newCapFormSubmited = false;
        this.bulkBeneficiary = false;
        this.disableOffice = false;
        this.NewPetition = action;
        this.selectedPetitioner = null;
        this.selectedBeneficiary = null;
        this.selectedUsername = null;
        this.selectedUser = null;
        this.premiumProcessing = false;
        this.newBeneficiary = [
          {
            firstName: '',
            middleName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ];
        this.selectedBranch = null;
        if ([3, 4, 50].indexOf(this.getUserRoleId) <= -1) {
          if (this.checkProperty(this.getUserData, 'branchDetails')) {
            let branchDetails = this.checkProperty(this.getUserData, 'branchDetails')
            this.selectedBranch = { "name": '', '_id': '' };
            this.selectedBranch['name'] = branchDetails['name'];
            this.selectedBranch['_id'] = branchDetails['_id'];
            this.disableOffice = true;
          } else if (this.branchList && this.branchList.length == 1) {
            this.selectedBranch = this.branchList[0]
          }
        } else if (this.branchList && this.branchList.length == 1) {
          this.selectedBranch = this.branchList[0]
        }
        this.showCapErrorCreatioInfo = false;
        if(this.canRegCap ==false){
          this.showCapErrorCreatioInfo = true;
        }else{
          
        
        this.$modal.show('newCapCreationModal');
        this.$validator.reset();
       }
      },
      checkCapRegcase(callFrommounted=false){
        this.showCapErrorCreatioInfo =false;
        this.canRegCap = false;
        this.$store.dispatch("commonAction", { "data": {}, "path": "/cap-registrations/can-create-case" }).then((response) => {
          this.canRegCap = response;
          
            if (callFrommounted && this.$route.params && this.$route.params.openCreatePopup) {
            var _s = this;
            setTimeout(() => {
            _s.openCreateCasePopup(false);
            
            }, 600)
            }
          
          
          })
      },
      updateAccount() {
        let tempList = [];
        _.forEach(this.newBeneficiary, (item) => {
          item['email'] = ''
          item['phone'] = ''
          item['phoneCountryCode'] = {
            countryCode: '',
            countryCallingCode: ''
          }
          tempList.push(item)
        })
        if (tempList && this.checkProperty(tempList, 'length') > 0) {
          this.newBeneficiary = tempList
        }
      },
      getInvoiceList(callFromSearch = false, callFromFilter = false) {
  
        this.callFromSearch = callFromSearch
        if (this.callFromSearch) {
          this.invoiceList = []
        }
        let Payload = {
          matcher: {
            title: this.searchtxt,
            petitionerIds: this.final_selected_peritioners,
            caseType: [],
            subType: [],
            caseStatus: this.final_selected_statusids,
            paymentStatus: this.final_selected_paymentstatusids,
            createdDateRange: [],
            dueDateRange: [],
          },
          page: this.page,
          perpage: this.perpage,
          sorting: this.sortKey,
          today: moment().format('YYYY-MM-DD'),
        }
        if (this.selectedVisaType && _.has(this.selectedVisaType, 'id')) {
        if (this.checkProperty(this.selectedVisaType, 'id') != 'ALL') {
            Payload["matcher"]["caseType"] = [this.selectedVisaType['id']];
            Payload["matcher"]["subType"] = this.final_selected_subtypes;
        }

      }
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        Payload["matcher"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }
      if (
        this.selected_deadLineDateRange["startDate"] &&
        this.selected_deadLineDateRange["startDate"] != "" &&
        this.selected_deadLineDateRange["endDate"] != "" &&
        this.selected_deadLineDateRange["endDate"]
      ) {
       
        Payload["matcher"]["dueDateRange"] = [
          this.selected_deadLineDateRange["startDate"],
          this.selected_deadLineDateRange["endDate"]
        ];
      }
        let tempObj={
          page: this.page,
          perpage: this.perpage,
          sortKey: this.sortKey,
        };
        this.setQueryString(tempObj);
        this.isListloading = true;
        this.updateLoading(true);
        this.$store.dispatch("commonAction", { "data": Payload, "path": "/invoices/list" }).then((response) => {
          this.isListloading = false;
          this.updateLoading(false);
          this.getActiveCases = false;
          this.invoiceList = response.list
          this.totalCount = this.checkProperty(response, 'totalCount')
          this.totalpages = Math.ceil(response.totalCount / this.perpage)
          setTimeout(() => {
            this.updateLoading(false);
          }, 10);
        })
          .catch((err) => {
            this.isListloading = false;
            this.updateLoading(false);
          })
      },
      setQueryString(obj){
        const string = JSON.stringify(obj) // convert Object to a String
        this.encodedString = btoa(string) // Base64 encode the String
        this.$route['query']['filter'] = this.encodedString;
      },
      filterQueryPreSelect(callFromMounted=false){
        if(this.checkProperty(this.$route ,'query' ,'filter')){
          try{
            let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
            var actual = JSON.parse(atob(filter));
            let keys = Object.keys(actual);
            if(this.checkProperty(keys ,'length') >0 ){
              if(_.has(actual ,'page') && this.checkProperty(actual ,'page')){                                     
                this.page = this.checkProperty(actual ,'page');
              }
              if(_.has(actual ,'perpage') && this.checkProperty(actual ,'perpage')){                                     
                this.perpage = this.checkProperty(actual ,'perpage');
              }
              if(_.has(actual ,'sortKey') && this.checkProperty(actual ,'sortKey')){   
                if(this.sortKeys){
                  this.sortKeys[actual['sortKey']['path']] = actual['sortKey']['order']
                }                                  
                this.sortKey = this.checkProperty(actual ,'sortKey');
              }
              if(_.has(actual ,'selectedStatus') && this.checkProperty(actual ,'selectedStatus') && this.checkProperty(actual ,'selectedStatus', 'length')>0){                                     
                this.selectedStatus = this.checkProperty(actual ,'selectedStatus');
              } 
              if(_.has(actual ,'selectedSeasons') && this.checkProperty(actual ,'selectedSeasons') && this.checkProperty(actual ,'selectedSeasons', 'length')>0){                                     
                this.selectedSeasons = this.checkProperty(actual ,'selectedSeasons');
              }
              if(_.has(actual ,'selected_peritioners') && this.checkProperty(actual ,'selected_peritioners') && this.checkProperty(actual ,'selected_peritioners', 'length')>0){                                     
                this.selected_peritioners = this.checkProperty(actual ,'selected_peritioners');
                this.changedperitioners();
              }
              if(_.has(actual ,'header_selected_petitioners') && this.checkProperty(actual ,'header_selected_petitioners') && this.checkProperty(actual ,'header_selected_petitioners', 'length')>0){                                     
                this.header_selected_petitioners = this.checkProperty(actual ,'header_selected_petitioners');
              }
              if(_.has(actual ,'selectedpremiumProcessing') && this.checkProperty(actual ,'selectedpremiumProcessing') && this.checkProperty(actual ,'selectedpremiumProcessing', 'length')>0){                                     
                this.selectedpremiumProcessing = this.checkProperty(actual ,'selectedpremiumProcessing');
              }
              if(_.has(actual ,'selectedtypeNames') && this.checkProperty(actual ,'selectedtypeNames') ){                                     
                this.selectedtypeNames = this.checkProperty(actual ,'selectedtypeNames');
              }
              if(_.has(actual ,'searchtxt') && this.checkProperty(actual ,'searchtxt') ){                                     
                this.searchtxt = this.checkProperty(actual ,'searchtxt');
              }
              if(_.has(actual ,'filter_searchtxt') && this.checkProperty(actual ,'filter_searchtxt') ){                                     
                this.filter_searchtxt = this.checkProperty(actual ,'filter_searchtxt');
              }
             // console.log("matchessss",actual)
              if(_.has(actual ,'initStatusIdsFilter') && this.checkProperty(actual ,'initStatusIdsFilter')){                                     
                this.initStatusIdsFilter = this.checkProperty(actual ,'initStatusIdsFilter');
                //console.log("this.initStatusIdsFilter",this.initStatusIdsFilter)
              } //selectedStatus
              if (_.has(actual, 'selectedStatus') && this.checkProperty(item, 'selectedStatus', 'length') > 0) {
                      let statusIds = _.map(item['selectedStatus'], (sid) => parseInt(sid))
                      //let selectedStatus = _.find(this.case_statusids ,{"id":parseInt(statusIds[0])}); 
                      this.selectedStatus = statusIds;
                      _.forEach(this.selectedStatus, (ite) => {
                        if ([12, 13, 22, 23, 24, 31].indexOf(ite) > -1) {
                          this.getActiveCases = false;
                          this.activeCases = false;
                          return false
                        }
                      })
                    }
              console.log(JSON.stringify(this.selectedSeasons))
              if(callFromMounted){
                if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
                  this.selectedSeasons.push(this.season[0]);
                }
              }
              this.set_filter();
            }else{
              if(callFromMounted){
                if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
                  this.selectedSeasons.push(this.season[0]);
                }
                this.set_filter();
              }else{
                this.set_filter();
              }
            }
          }catch(e){
            if(callFromMounted){
              this.set_filter(callFromMounted);
            }
          }   
        }
        else{
          if(callFromMounted){
            if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
              this.selectedSeasons.push(this.season[0]);
            }
              this.set_filter(callFromMounted);
          }
        } 
      },
      addMore() {
        this.$validator.validateAll("newinvitepetitionerform").then((result) => {
          if (result) {
            let obj = {
              firstName: '',
              middleName: '',
              lastName: '',
              name: "",
              email: "",
              phone: "",
              phoneCountryCode: { countryCode: '', countryCallingCode: '' }
            }
            this.newBeneficiary.push(obj);
            this.$validator.reset("newinvitepetitionerform");
          }
        })
      },
      removeBenField: function (index) {
        this.newBeneficiary.splice(index, 1);
      },
      remove(item, data, filindex) {
        data.splice(filindex, 1);
        //this.disablePWDstatus = false;
        this.removeFileFromS3(item)
      },
      updatecellPhoneCountryCodee(data = '', index = '') {
        this.newBeneficiary[index]['phoneCountryCode'] = data
      },
     
      createNewCap() {
        if (this.bulkBeneficiary) {
          this.$validator.validateAll('newinvitepetitionerform').then(result => { })
        }
        this.$validator.validateAll('newCapCreationform').then(result => {
          if (result) {
            if (this.bulkBeneficiary) {
              this.$validator.validateAll('newinvitepetitionerform').then(result => {
                if (result) {
                  let payLoad = {
                    beneficiariesList: [],
                    today: moment().format('YYYY-MM-DD'),
                    branchId: '',
                    petitionerId: '',
                  };
                  if (this.getTenantTypeId != 2) {
                    if ([50].indexOf(this.getUserRoleId) > -1) {
                      payLoad['petitionerId'] = this.$store.state.user._id
  
                    } else {
                      payLoad['petitionerId'] = this.checkProperty(this.selectedPetitioner, "userId")
                    }
                  }
                  if (this.selectedBranch && _.has(this.selectedBranch, "_id")) {
                    payLoad['branchId'] = this.selectedBranch['_id']
                  }
                  if (this.withAccount == 'true' || this.withAccount == true) {
                    _.forEach(this.newBeneficiary, (item) => {
                      if (_.has(item, 'name')) {
                        if (_.has(item, 'middleName') && this.checkProperty(item, 'middleName')) {
                          item['name'] = item['firstName'].trim() + " " + item['middleName'].trim() + " " + item['lastName'].trim();
                        }
                        else {
                          item['name'] = item['firstName'].trim() + " " + item['lastName'].trim();
                        }
                      }
                      payLoad['beneficiariesList'].push(item)
                    })
                  }
                  if (this.withAccount == 'false' || this.withAccount == false) {
                    _.forEach(this.newBeneficiary, (item) => {
                      if (_.has(item, 'name')) {
                        //item['name'] = item['firstName'].trim() + " " + item['middleName'].trim() + " " + item['lastName'].trim();
                        if (_.has(item, 'middleName') && this.checkProperty(item, 'middleName')) {
                          item['name'] = item['firstName'].trim() + " " + item['middleName'].trim() + " " + item['lastName'].trim();
                        }
                        else {
                          item['name'] = item['firstName'].trim() + " " + item['lastName'].trim();
                        }
                        item['email'] = ''
                        item['phone'] = ''
                        item['phoneCountryCode'] = {
                          countryCode: '',
                          countryCallingCode: ''
                        }
                      }
                      payLoad['beneficiariesList'].push(item)
                    })
                  }
                  this.newCapFormSubmited = true;
                  let path = '/cap-registrations/bulk-create'
                  this.$store.dispatch("commonAction", { "data": payLoad, "path": path })
                    .then((response) => {
                      this.newCapFormSubmited = false;
                      this.NewPetition = false;
                      this.$modal.hide('newCapCreationModal')
                      this.openCreateCasePopup(false)
                      this.getInvoiceList()
                      this.showToster({ message: response.message, isError: false });
                    }).catch((err) => {
                      this.capCreationErrors = err;
                      this.newCapFormSubmited = false;
                    })
                }
              })
            }
  
            else {
              let Payload = {
                userId: "",
                userName: "",
                today: moment().format('YYYY-MM-DD'),
                branchId: "",
                petitionerId: "",
              }
              if (this.selectedUser) {
                Payload['userId'] = this.selectedUser
              }
              if (this.selectedUsername) {
                Payload['userName'] = this.selectedUsername
              }
              if (this.getTenantTypeId != 2) {
                if ([50].indexOf(this.getUserRoleId) > -1) {
                  Payload['petitionerId'] = this.$store.state.user._id
  
                } else {
                  Payload['petitionerId'] = this.checkProperty(this.selectedPetitioner, "userId")
                }
              }
              if (this.selectedBranch && _.has(this.selectedBranch, "_id")) {
                Payload['branchId'] = this.selectedBranch['_id']
              }
              this.newCapFormSubmited = true;
              let path = '/cap-registrations/create'
              this.$store.dispatch("commonAction", { "data": Payload, "path": path })
                .then((response) => {
                  this.newCapFormSubmited = false;
                  this.NewPetition = false;
                  this.$modal.hide('newCapCreationModal')
                  this.openCreateCasePopup(false)
                  this.getInvoiceList()
                  this.showToster({ message: response.message, isError: false });
                  if (this.checkProperty(response, '_id')) {
                    let routedId = this.checkProperty(response, '_id')
                    setTimeout(() => {
                      this.$router.push({ path: `/cap-registration-details/${routedId}`, query: { 'filter': this.encodedString } })
                    })
                  }
                })
                .catch((err) => {
                  this.newCapFormSubmited = false;
                  this.capCreationErrors = err;
                })
            }
  
          }
        })
      },
      clearMoreBen() {
        this.bulkBeneficiary = false;
        this.newBeneficiary = [
          {
            firstName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ];
  
      },
      changedCaseTypes() {
        this.selectedtypeNames = this.headerTypeNames
        if (this.selectedtypeNames) {
          this.set_filter();
        }
      },
      pageNate(pageNum) {
  
        this.page = pageNum;
        this.getInvoiceList();
      },
      changedperitioners() {
        this.$router.push({ query: {} })
        this.final_selected_peritioners = [];
        if (this.selected_peritioners.length > 0) {
          for (let i = 0; i < this.selected_peritioners.length; i++) {
            this.final_selected_peritioners.push(
              this.selected_peritioners[i]["userId"]
            );
          }
        }
        //this.get_peritioners_beneficiaries();
      },
      changedperitionersSearch() {
        this.selected_peritioners = this.header_selected_petitioners
        this.$router.push({ query: {} })
        this.final_selected_peritioners = [];
        if (this.selected_peritioners.length > 0) {
          for (let i = 0; i < this.selected_peritioners.length; i++) {
            this.final_selected_peritioners.push(
              this.selected_peritioners[i]["userId"]
            );
          }
        }
        this.set_filter();
      },
      peritioners_search_fun(searchText) {
        clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.getPetitioners(true, searchText);
          }, 900)
        
        //this.peritioners_search_value = searchValue;
        //this.get_peritioners();
      },
      changeperPage() {
        this.page = 1;
        localStorage.setItem('petitions_perpage', this.perpage);
        this.getInvoiceList(true);
      },
      sortMe(sort_key = '') {
        if (sort_key != '') {
          this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
          this.sortKey = {};
          this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }
          localStorage.setItem('petitions_sort_key', sort_key);
          localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
          this.getInvoiceList();
        }
      },
      getBranchList() {
  
        this.branchList = [];
        let item = {
          filters: {
            "title": '',
            "createdDateRange": [],
            "statusList": [],
            "activeList": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": []
          },
          getMasterData: true,
          page: 1,
          perpage: 1000,
          sorting: { "path": "createdOn", "order": -1 },
  
        };
        this.$store
          .dispatch("getList", { "data": item, "path": "/branch/list" })
          .then(response => {
  
            this.branchList = response.list;
            if (this.branchList.length == 1) {
              this.selectedBranch = this.branchList[0];
            }
          }).catch((error) => {
            this.branchList = [];
          })
      },
      upDateBenef() {
        this.clearMoreBen()
        if (this.checkProperty(this.selectedBeneficiary, 'name') && this.checkProperty(this.selectedBeneficiary, '_id')) {
          this.selectedUser = this.checkProperty(this.selectedBeneficiary, '_id');
          this.selectedUsername = this.checkProperty(this.selectedBeneficiary, 'name');
        }
      },
      set_filter: function (callFromMounted = false, clearSubType = false) {
        this.searchtxt = this.filter_searchtxt;
        if (clearSubType) {
        this.final_selected_subtypes = [];
        this.selected_subtypes = [];
        this.selected_statusids = [];
      }
        if (this.initStatusIdsFilter) {
          this.checkHeaderCheckBox = this.initStatusIdsFilter
          if (this.initStatusIdsFilter && this.initStatusIdsFilter.id == 1) {
            this.activeCases = true;
            this.getFiledCases = false;
          }
          else {
            this.activeCases = false;
  
          }
          if (this.initStatusIdsFilter && this.initStatusIdsFilter.id == 10) {
            this.activeCases = false;
            this.getFiledCases = true;
            
          }
          if (this.initStatusIdsFilter && [2, 3, 4, 9].indexOf(this.initStatusIdsFilter) > -1) {
            this.activeCases = false;
            this.getFiledCases = false;
           
          }
          
        
         // this.checkInternalStatusTitle()
        }
        if (this.initStatusIdsFilter == null) {
          this.activeCases = false;
          //console.log("this.initStatusIdsFilter == null")
        }
        if (this.selected_statusids) {
        if (!callFromMounted) {
          this.final_selected_statusids = [];
        }
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }
      if (this.selected_paymentstatusids) {
        if (!callFromMounted) {
          this.final_selected_paymentstatusids = [];
        }
        for (let ind = 0; ind < this.selected_paymentstatusids.length; ind++) {
          let current_index = this.selected_paymentstatusids[ind];
          this.final_selected_paymentstatusids.push(current_index["id"]);
        }
      }
        if (this.selectedStatus && this.checkProperty(this.selectedStatus, 'length') > 0) {
          _.forEach(this.selectedStatus, (it) => {
            if ([7,6,8,11,9,10,91].indexOf(it['id']) > -1) {
              this.activeCases = false;
              this.initStatusIdsFilter=null
              return false
            }
          })
        }
        this.getInvoiceList();
        this.headerTypeNames = this.selectedtypeNames;
        this.header_selected_petitioners = this.selected_peritioners
        this.$refs["filter_menu"].dropdownVisible = false;
      },
      clear_filter: function () {
        this.final_selected_statusids=[]
        this.final_selected_paymentstatusids=[]
        this.selected_subtypes = [];
        this.selected_statusids = [];
        this.selected_paymentstatusids=[]
        this.selectedVisaType = []
        this.activeCases = true;
        this.initStatusIdsFilter=null,
        this.selectedSeasons = [];
        this.selectedStatus = [];
        this.selectedpremiumProcessing = [];
        this.selectedtypeNames = [];
        this.final_selected_peritioners = [];
        this.selected_peritioners = [];
        this.searchtxt = '';
        this.filter_searchtxt = '';
        this.initStatusIdsFilter = { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" };
        this.page = 1;
        this.getInvoiceList();
        this.headerTypeNames = [];
        this.header_selected_petitioners = [];
        this.selected_createdDateRange["startDate"] = "";
        this.selected_createdDateRange["endDate"] = "";
        this.selected_deadLineDateRange["startDate"] = "";
        this.selected_deadLineDateRange["endDate"] = "";

        this.$refs["filter_menu"].dropdownVisible = false;
  
      },
      petitionerUpdated() {
        this.selectedBeneficiary = null;
        this.selectedUser = '';
        this.selectedUsername = '';
        this.getbeneficiaryMasterDataList();
      },
      getbeneficiaryMasterDataList(text = '') {
        let postData = {
          "matcher": {
            "title": text,
            "statusList": [],
            "branchIds": [],
            "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
            "createdByIds": [],
            "createdDateRange": [],
            "roleIds": [51],
            "statusIds": [],
            "petitionTypeIds": [],
            "petitionSubTypeIds": [],
            "petitionCreatedDateRange": [],
            "petitionStatusIds": [],
            "getPetitionStats": true
          },
          "sorting": {
            "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
            "order": 1
          },
          "page": 1,
          "perpage": 1000000,
          "getMasterData": true,
          "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
          "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
        };
  
        this.enableAddNewBenTag = false;
        if (this.checkProperty(this.selectedPetitioner, "_id")) {
  
          postData['companyId'] = this.selectedPetitioner['_id']
  
        }
        if ([50, 51].indexOf(this.getUserRoleId) > -1) {
  
          postData['companyId'] = this.checkProperty(this.getUserData, "companyDetails", "_id")
        }
        //this.beneficiaryMasterDataList =[];
        this.$store
          .dispatch("petitioner/getbeneficiaries", postData)
          .then(response => {
            this.beneficiaryMasterDataList = response.list;
  
            let filteredData = [];
            _.forEach(this.beneficiaryMasterDataList, (item) => {
              if (item && (_.has(item, 'name') || _.has(item, 'email'))) {
  
                if ((_.has(item, 'name') && item['name'].includes(text)) || (_.has(item, 'email') && item['email'].includes(text))) {
                  filteredData.push(item)
                } else {
                  return false;
                }
  
              } else {
                return false;
              }
  
  
            })
  
            if(filteredData.length<=0){
             this.enableAddNewBenTag =true;
           }
           let  beneficiaryMasterDataList = _.cloneDeep(this.beneficiaryMasterDataList);
           this.beneficiaryMasterDataList =[];
           _.forEach(beneficiaryMasterDataList, (item)=>{
            if(this.checkProperty(item,'name')){
              if(this.checkProperty(item ,'email') ){
                item['name'] =  item['name']+" ("+item['email']+")"
              }
              this.beneficiaryMasterDataList.push(item);
            }
          
          })
  
  
          })
  
      },
      petitionlink(tr) {
        let routedId = this.checkProperty(tr, '_id')
        //this.$router.push('/cap-registration-details/'+this.checkProperty( tr,'_id'))ap-registration-questionnaire
        this.$router.push({ path: `/cap-registration-details/${routedId}`, query: { 'filter': this.encodedString } })
        //this.$router.push({path: `/cap-registration-questionnaire/${routedId}` ,query: {'filter':this.encodedString} })    
      },
      selectedForNext() {
        let selectedCaps = _.filter(this.capList, { "isSelected": true });
        if (selectedCaps && this.checkProperty(selectedCaps, 'length') > 0) {
          this.enableNextBtn = true;
          this.selectAllForArchive = false
        }
  
        else {
          this.enableNextBtn = false;
          this.selectAllForArchive = false
        }
      },
      selectedAllForNext() {
        if (this.selectAllForArchive) {
          _.map(this.capList, (item) => { item['isSelected'] = true })
          this.enableNextBtn = true;
        }
        else {
          _.map(this.capList, (item) => { item['isSelected'] = false })
          this.enableNextBtn = false;
        }
      },
      updatecellPhoneCountryCode(data) {
        this.beneficiary['phoneCountryCode'] = data
      },
      updateSelection() {
  
        if (this.wiseSelection == 'true') {
          this.anonymousUser = false;
  
  
        } else {
          this.anonymousUser = true;
          this.beneficiary.email = '';
          this.beneficiary.phone = ''
          this.beneficiary.phoneCountryCode = { countryCode: '', countryCallingCode: '' };
        }
  
        // this.resetForm();
      },
      setPetDetails(selectedPetitioner = null) {
  
        this.selectedPetitioner = selectedPetitioner
      },
      addNewBeneficiary() {
        this.selectedPetitioner = null;
        this.beneficiary = {
          firstName: '',
          lastName: '',
          name: "",
          email: "",
          phone: "",
          phoneCountryCode: { countryCode: '', countryCallingCode: '' }
        }
        Object.assign(this.formerrors, {
          msg: ''
        });
  
        this.AddBeneficiary = true;
        this.$validator.reset();
        this.isPhoneValid = true;
        this.saveBenbtn = false;
  
  
      },
      updatePhone(item) {
  
        this.isPhoneValid = true;
  
        if (item.isValid) {
  
          this.beneficiary.phoneCountryCode = { countryCode: item.countryCode, countryCallingCode: item.countryCallingCode };
          this.beneficiary.phone = item.nationalNumber;
  
        } else {
          if (this.count > 5)
            this.isPhoneValid = false;
        }
        this.count++;
      },
      savebeneficiary() {
        this.$validator.validateAll().then(result => {
  
          this.saveBenbtn = false;
          if (result) {
            let self = this;
            this.beneficiary = Object.assign(this.beneficiary, { "roleId": 51 });
            this.beneficiary['name'] = this.beneficiary['firstName'].trim() + " " + this.beneficiary['lastName'].trim();
            this.beneficiary['firstName'] = this.beneficiary['firstName'].trim();
            this.beneficiary['lastName'] = this.beneficiary['lastName'].trim();
            this.beneficiary['name'] = this.beneficiary['name'].trim();
            this.saveBenbtn = true;
            let postData = this.beneficiary;
            if (this.checkProperty(this.selectedIItem, '_id')) {
              postData['userId'] = this.checkProperty(this.selectedIItem, '_id')
              postData['accountType'] = "Individual"
            }
            if (this.selectedIItem == null) {
              if (self.selectedPetitioner && _.has(self.selectedPetitioner, "_id")) {
                postData = Object.assign(postData, { "companyId": self.selectedPetitioner['_id'] })
              }
            }
            let path = "/users/register"
            if (this.checkProperty(this.selectedIItem, '_id')) {
              path = "/users/invite-temp-user-to-individual"
            }
  
            this.$store
              .dispatch("commonAction", { "data": postData, "path": path })
              .then(response => {
                this.saveBenbtn = false;
                if (response.error) {
  
                  Object.assign(this.formerrors, {
                    msg: response.error.message
                  });
                } else {
  
                  this.AddBeneficiary = false;
                  this.selectedBeneficiary = response
                  this.showToster({ message: response.message, isError: false });
                  //this.closeAddBenPopUp();
                }
  
                // this.$router.go('/beneficiaries');
              })
              .catch((err) => {
  
                this.saveBenbtn = false;
                //this.showToster({message:err,isError:true })
                Object.assign(this.formerrors, {
                  msg: err
                });
  
              });
          }
        });
      },
      searchPet(searchText) {
        let _self = this;
  
        this.enableAddNewpet = false;
        let filteredData = [];
        _.forEach(_self.petitionersList, (item) => {
          if (item && (_.has(item, 'name') || _.has(item, 'email'))) {
  
            if ((_.has(item, 'name') && item['name'].includes(searchText)) || (_.has(item, 'email') && item['email'].includes(searchText))) {
              filteredData.push(item)
            } else {
              return false;
            }
  
          } else {
            return false;
          }
  
  
        })
        if ((filteredData.length <= 0)) {
  
          //this.enableAddNewpet =true;
          // this   this.addNewPete = true;
          this.getPetitioners(true, searchText);
        }
  
      },
      getPetitioners(callFromSerch = false, searchText = '') {
  
        let _self = this;
        let query = {
          "matcher": {
            "searchString": searchText,
            "statusIds": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": []
          },
          "sorting": { "path": "createdOn", "order": 1 },
          "page": 1,
          "perpage": 100,
          getMasterData: true
        }
  
  
        this.$store.dispatch("getList", { data: query, path: '/company/list' }).then(response => {
  
          _self.petitionersList = response.list;
  
        }).catch((err) => {
          this.petitionersList = [];
  
        })
      },
      addNewPet(newPet = '', id) {
        this.newPetOpenFromben = false;
        this.openNewbenForm = false;
        this.addNewPete = true;
        this.invitePetitionPopupshow(true)
      },
      closenewPetPopup(selectedPetitioner = null) {
        this.getPetitioners();
        this.selectedPetitioner = selectedPetitioner;
        this.invitePetitionPopupshow(false);
        this.openNewbenFormPopup(true);
      },
      invitePetitionPopupshow(action = true) {
        this.invitepetitioner = action;
  
        if (!action) {
          this.selectedBeneficiary = null;
        }
  
  
      },
      openNewbenFormPopup(action = false) {
        this.saveBenbtn = false;
        if (action == true) {
          this.invitePetitionPopupshow(false);
        }
        if (action) {
          if (this.checkProperty(this.selectedPetitioner, 'userId')) {
            this.AddBeneficiary = true;
            try {
              setTimeout(() => {
                this.$refs['add_ben'].setPetDetails(this.selectedPetitioner)
              }, 50)
            } catch (e) {}
          } else {
            this.AddBeneficiary = false;
          }
        } else {
          this.AddBeneficiary = action;
        }
        this.$validator.reset();
      },
      // addNewPet(){
      //    this.$emit("openAddpetPopUp" );
      // },
      openAddpetPopUp() {
  
        this.selectedPetitioner = null;
        this.invitepetitioner = true;
      },
      closeAddBenPopUp(selectedBeneficiary = null) {
  
        this.AddBeneficiary = false;
        this.selectedBeneficiary = selectedBeneficiary;
        if (this.checkProperty(this.selectedBeneficiary, 'name') && this.checkProperty(this.selectedBeneficiary, '_id')) {
          this.selectedUser = this.checkProperty(this.selectedBeneficiary, '_id');
          this.selectedUsername = this.checkProperty(this.selectedBeneficiary, 'name');
        }
        this.getbeneficiaryMasterDataList();
      },
      // closeAddBenPopUp(){
      //   let self =this;
      //   if(this.checkProperty(this.selectedBeneficiary ,"_id")){
  
      //     this.selectedBeneficiary = Object.assign(this.selectedBeneficiary ,{"anonymousUser": self.anonymousUser});
  
      //   }
      //     this.$emit("closeAddBenPopUp" ,this.selectedBeneficiary);
      // },
      getMasterDataList() {
        this.caseStatusList = [];
        this.$store.dispatch("getmasterdata", "education_types").then((response) => {
          this.education_types = response;
        });
        this.$store.dispatch("getmasterdata", "cap_reg_status").then((response) => {
          this.caseStatusList = response;
          //let obj1 = {_id: "63f783dc7aca563b7e5865485", id: 90, name: "Active", sortName: "Active"};
          let obj2 = { _id: "63f783dc7aca2865dd5555855", id: 91, name: "Hold", sortName: "Hold" };
          //this.caseStatusList.push(obj1)
          this.caseStatusList.push(obj2)
  
        });
      },
  
  
    },
    mounted() {
      if (this.checkProperty(this.getUserData, 'tenantDetails') && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg') {
        this.isSlg = false;
      }
      // this.checkCapRegcase(true);
     
      this.sortKeys = {
        'customId': 1,
        'IssuedToDetails': 1,
        "amount": 1,
        "caseType": 1,
        "caseStatus": 1,
        "createdOn": 1,
        "updatedOn": -1,
        "paymentStatus": 1,
        "beneficiaryName": 1,
  
      },
        this.sortKey = { "path": 'updatedOn', "order": -1 };
  
      if (localStorage.getItem('petitions_sort_key') && localStorage.getItem('petitions_sort_value') && localStorage.getItem('petitions_sort_value') >= -1) {
        this.sortKey = {};
        this.sortKey = { "path": localStorage.getItem('petitions_sort_key'), "order": parseInt(localStorage.getItem('petitions_sort_value')) };
        this.sortKeys[localStorage.getItem('petitions_sort_key')] = parseInt(localStorage.getItem('petitions_sort_value'));
      }
      this.caseStatus();
      this.getMasterDataList()
      //caseStatusList
      this.getVisaTypes();
      this.getPetitioners();
      this.getbeneficiaryMasterDataList();
      this.getBranchList();
      this.getInternalStatusList();
      this.initStatusIdsFilter = { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" };
      this.filterQueryPreSelect(true);
  
      try{
  
          document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible") {
              // Tab has become active
              console.log("Tab is now active");
            
              // You can perform actions here when the tab becomes active
            } else {
              // Tab has become inactive
              console.log("Tab is now inactive");
              // You can perform actions here when the tab becomes inactive
            }
          });
  
  
          }catch(error){
            console.log(error);
          }
    },
    computed: {
      
      
    },
   
  };
  </script>